import { queryOptions, UseQueryOptions } from "@tanstack/react-query";
import fetcher from "~/components/build/Show/lib/fetcher";

export const jobArtifactsCountQueryKey = (jobBasePath: string) => {
  return [jobBasePath, "artifacts-count"];
};

export const jobArtifactsCountQueryOptions = (
  jobBasePath: string,
  queryOptionsArgs: Omit<UseQueryOptions<number>, "queryKey" | "queryFn"> = {},
) => {
  return queryOptions({
    queryKey: jobArtifactsCountQueryKey(jobBasePath),
    queryFn: () => fetchJobArtifactsCount(jobBasePath),
    ...queryOptionsArgs,
  });
};

function fetchJobArtifactsCount(jobBasePath: string): Promise<number> {
  const url = new URL(`${jobBasePath}/artifacts/count`, window.location.origin);

  return fetcher<number>(url);
}
